import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, styled } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})(({ isHidden }) => ({
  display: isHidden && 'none',
}));

export const DatePickerStyled = styled(
  DesktopDatePicker,
  MobileDatePicker,
)(({ theme, error, disabled, value }) => {
  const getBorderColor = () => {
    if (error) return theme.palette.colors.down;

    if (disabled)
      return `${theme.palette.colors.secondaryDisabledText} !important`;

    return theme.palette.colors.borderLine;
  };

  return {
    width: '100%',
    height: '32px',

    '&:hover fieldset': {
      border: `1px solid ${getBorderColor()} !important`,
    },

    '& fieldset': {
      border: `1px solid ${getBorderColor()}`,
    },

    '& .MuiPickersOutlinedInput-root': {
      paddingLeft: 0,
      backgroundColor: theme.palette.colors.secondaryBackground,

      '& .MuiPickersInputBase-sectionsContainer': {
        WebkitTextFillColor: !value
          ? theme.palette.colors.placeholderText
          : theme.palette.colors.onSecondaryAndDetailBackground,
        color: !value
          ? theme.palette.colors.placeholderText
          : theme.palette.colors.onSecondaryAndDetailBackground,
        fontWeight: 500,
        padding: '8px 0 7px 8px',
        fontSize: '12px',
        fontStyle: !value && 'italic',
        opacity: 1,

        '&::placeholder': {
          fontStyle: 'italic',
          color: theme.palette.colors.placeholderText,
          opacity: 1,
        },
      },
    },

    '& .Mui-disabled': {
      backgroundColor: theme.palette.colors.secondaryDisabledBackground,
      WebkitTextFillColor: `${theme.palette.colors.secondaryDisabledText} !important`,

      '& .fa-calendar-days > *': {
        color: theme.palette.colors.secondaryDisabledText,
      },
    },
  };
});

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
